import { getHoverRow } from "../utils";
import { generateIntegratedData, importSession } from "./migrationUtils";
import { extendObservable } from "mobx";
import { getType, isType } from "@utils";

/**
 * 单个加入迁移清单的的action
 * @param rootStore
 * @param options
 * @param event
 * @param eventOptions
 */
export const addMigration = {
  async doAction(
    rootStore: any,
    options: any = {},
    event: any,
    eventOptions: any
  ) {
    const that = this
    const {
      pageStore: { params = {}, query = {} } = {},
      context,
      utils = {},
    } = rootStore;

    const locale: string = context?.locale || "zh_CN";
    const serviceCode: string = query?.serviceCode;
    const [hoverRow, tableStore] = getHoverRow.apply(this, arguments);
    if (!hoverRow) throw new Error(`The hoverRow not found`);
    // const serviceCode = viewmodel.getServiceCode()
    // const paramObj = cb.utils.parseCParameter(params.cmdParameter);
    // const gridModel = viewmodel.getGridModel();
    // const index = params.params.index
    // const item = gridModel.get('dataSource')[index]
    jDiwork?.getData({ serviceCode }, async (args: any) => {
      // const arg = {
      //   iframeTitle: "特征",
      //   iframeWidth: 1704,
      //   iframeHeight: 194,
      //   sourceCode: "workbench",
      //   serviceInfo: {
      //     serviceCode: "base_characterlist",
      //     serviceName: "特征",
      //     serviceIcon:
      //       "https://cdn.yonyoucloud.com/workapplation/icon/15.png",
      //     serviceNameMultiLangText: {
      //       zh_TW: "特徵",
      //       en_US: "Character",
      //       zh_CN: "特征",
      //       fr_FR: "",
      //       ja_JP: "",
      //       de_DE: "",
      //     },
      //     applicationCode: "CHARACTER",
      //     labelCode: "PF",
      //     labelMultiLangText: {
      //       zh_TW: "數字化建模",
      //       en_US: "Digital Modeling",
      //       zh_CN: "数字化建模",
      //     },
      //     applicationMultiLangText: {
      //       en_US: "Character Management",
      //       zh_CN: "特征管理",
      //     },
      //   },
      // };
      // TODO: 需要获取公共参数里面的迁移配置是否开启
      if (!rootStore?.globalConfig?.commonOption?.enableMigration) {
        // if (!cb.context.getCommonOptionValue("enableMigration")) {
        // lang.templateByUuid('UID:P_FW_198CE2F604F80000', '提示：当前租户暂未开启配置迁移功能，请联系管理员在公共参数开启。')
        utils.message?.warning(
          lang.templateByUuid(
            "UID:P_FW_198CE2F604F80000",
            "提示：当前租户暂未开启配置迁移功能，请联系管理员在公共参数开启。",
            undefined,
            { returnStr: true }
          )
        );
      } else {
        let data = generateIntegratedData(locale, hoverRow, args, options);
        if (isType(that.berforeChangeData, 'Function')) {
          data = await that.berforeChangeData(rootStore, data);
        }
        const isDuplicateData = importSession(data, rootStore);
        if (
          getType(rootStore?.addMigrationRefresh).toLocaleLowerCase() ==
          "undefined"
        ) {
          extendObservable(rootStore, {
            addMigrationRefresh: true,
          });
        } else {
          rootStore.addMigrationRefresh = true;
        }
        if (isDuplicateData) {
          utils.message.warning(
            lang.templateByUuid(
              "UID:P_AUTHF_1989A71004100014",
              "数据重复请检查数据"
            )
          );
        }
      }
    });
  },
};
